import React, {useEffect, useState} from "react";
import {Box, Button, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ReactComponent as MyListIcon} from "./../../img/myList.svg";
import {ReactComponent as PlusIcon} from "./../../img/add_icon.svg";
import {ReactComponent as ReturnIcon} from "./../../img/return_icon.svg";
import {ReactComponent as TrashIcon} from "./../../img/trash_icon.svg";
import {useDispatch, useSelector} from "react-redux";
import {
    addItemsToPrintListDispatcher,
    addPromosToPrintListDispatcher,
    togglePrintListDispatcher
} from "../../Redux/content-reducer";
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles(theme => ({
    screenPrintListControlsWrapper: {
        display: `flex`,
        justifyContent: `flex-end`,
        alignItems: `center`,
        height: `100%`,
    },
    printBtnWrapper: (props) => ({
        display: `flex`,
        position: `relative`,
        justifyContent: `flex-end`,
        alignItems: `center`,
        height: `100%`,
        '& > .MuiButton-root': {
            width: props.isLaptop ? `175px` : `264px`,
            height: `34px`,
            backgroundColor: theme.palette.primary.main,
            '&.Mui-disabled': {
                backgroundColor: theme.palette.primary.light
            }
        }
    }),
    printListBtnBox: {
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`
    },
    bubbleCount: {
        position: `absolute`,
        left: `-20px`,
        bottom: `-10px`,
        minWidth: `30px`,
        maxWidth: `100px`,
        height: `20px`,
        backgroundColor: `white`,
        outline: `1px solid ${theme.palette.primary.main}`,
        padding: `0 5px`,
        borderRadius: `5px`,
        zIndex: 5
    }
}))

export const ScreenPrintListControls = () => {
    const dispatch = useDispatch();
    const {contentData, dropdownsReducer} = useSelector(state => state);
    const isLaptop = useMediaQuery({ query: '(max-width: 1536px)' });
    const stylesProperties = {
        isLaptop: isLaptop
    }
    const classes = useStyles(stylesProperties);

    const selectedOptionValue = localStorage.getItem("selectedOptionValue");
    const [selectedRows, changeSelectedRows] = useState([]);
    const [countItemOrPromosInPrintList, setCount] = useState(0);

    // const countOfPrintList
    useEffect(() => {
        if(contentData.isActivePromosScreen){
            if(contentData.isPrintListOpened){
                const selectedRows = contentData.printListDataForPromos.filter((key) => {
                    if(key.selectedRow){
                        return key;
                    }
                });
                changeSelectedRows(selectedRows);
            } else {
                const selectedRows = contentData.data.filter((key) => {
                    if(key.selectedRow){
                        return key;
                    }
                });
                changeSelectedRows(selectedRows);
            }
        } else {
            if(contentData.isPrintListOpened){
                const selectedRows = contentData.printListDataForItems.filter((key) => {
                    if(key.selectedRow){
                        return key;
                    }
                });
                changeSelectedRows(selectedRows);
            } else {
                const selectedRows = contentData.dataForRegPrices.filter((key) => {
                    if(key.selectedRow){
                        return key;
                    }
                });
                changeSelectedRows(selectedRows);
            }
        }

    }, [contentData.data,
        contentData.dataForRegPrices,
        contentData.printListDataForItems,
        contentData.printListDataForPromos,
        contentData.isPrintListOpened,
        contentData.isActivePromosScreen
    ]);

    useEffect(() => {
        if(contentData.isActivePromosScreen){
            setCount(contentData.printListDataForPromos.length);
        } else {
            setCount(contentData.printListDataForItems.length);
        }
    }, [contentData.printListDataForPromos, contentData.printListDataForItems, contentData.isActivePromosScreen])

    const addSelectedRowsToPrintList = () => {
        if(contentData.isPrintListOpened){
            if(contentData.isActivePromosScreen){
                const promosDontNeedToBeRemoved = [...contentData.printListDataForPromos].filter(key => !key.selectedRow);
                localStorage.setItem(`printListForPromos${selectedOptionValue}`, JSON.stringify(promosDontNeedToBeRemoved));
                dispatch(addPromosToPrintListDispatcher(promosDontNeedToBeRemoved));
            } else {
                const itemsDontNeedToBeRemoved = [...contentData.printListDataForItems].filter(key => !key.selectedRow);
                localStorage.setItem(`printListForItems${selectedOptionValue}`, JSON.stringify(itemsDontNeedToBeRemoved));
                dispatch(addItemsToPrintListDispatcher(itemsDontNeedToBeRemoved));
            }
        } else {
            if(contentData.isActivePromosScreen){
                try {
                    const selectedPromos = contentData.data.filter(key => key.selectedRow);
                    const seen = new Set();
                    const printListForPromosPossibleArray = [...selectedPromos, ...contentData.printListDataForPromos];
                    const printListForPromos = printListForPromosPossibleArray.filter((promo) => {
                        const duplicate = seen.has(promo.SaleIdentifier);
                        seen.add(promo.SaleIdentifier);
                        return !duplicate;
                    });
                    if(printListForPromos.length > 500){
                        alert(`The Print List can't contain more than 500 promotions.`);
                        return;
                    }
                    dispatch(addPromosToPrintListDispatcher(printListForPromos));
                    //set print promos list to localstorage
                    localStorage.setItem(`printListForPromos${selectedOptionValue}`, JSON.stringify(printListForPromos));
                } catch (err){
                    console.log(err);
                }
            } else {
                try {
                    const selectedItems = contentData.dataForRegPrices.filter(key => key.selectedRow);
                    const seen = new Set();
                    const printListForItemsPossibleArray = [...selectedItems, ...contentData.printListDataForItems];
                    const printListForItems = printListForItemsPossibleArray.filter((promo) => {
                        const duplicate = seen.has(promo.EffectiveBarCode);
                        seen.add(promo.EffectiveBarCode);
                        return !duplicate;
                    });
                    if(printListForItems.length > 500){
                        alert(`The Print List can't contain more than 500 items.`);
                        return;
                    }
                    localStorage.setItem(`printListForItems${selectedOptionValue}`, JSON.stringify(printListForItems));
                    dispatch(addItemsToPrintListDispatcher(printListForItems));
                } catch (err){
                    console.log(err);
                }
                //set print items list to localstorage
            }
        }
    }

    const showPrintList = () => {
        dispatch(togglePrintListDispatcher(contentData.isPrintListOpened));
    }

    return (
        <Box className={classes.screenPrintListControlsWrapper}>
            <Box className={classes.printBtnWrapper}>
                <Button sx={{mx: `10px`}} disabled={selectedRows.length === 0} onClick={addSelectedRowsToPrintList}>
                    <Grid container>
                        <Grid item xs={2}>
                            <Box className={classes.printListBtnBox}>
                                {
                                    contentData.isPrintListOpened ?
                                        <TrashIcon/> :
                                        <PlusIcon />
                                }
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box className={classes.printListBtnBox}>
                                <Typography color={`white`} variant={isLaptop ? `body1` :`body2`}>
                                    {contentData.isPrintListOpened ? `מחיקת שלטים נבחרים`: `הוספה לרשימת הדפסה`}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Button>
            </Box>
            <Box className={classes.printBtnWrapper}>
                <Button onClick={showPrintList} disabled={!contentData.isPrintListOpened && (countItemOrPromosInPrintList === 0 || contentData.isPreloader)}>
                    <Grid container>
                        <Grid item xs={2}>
                            <Box className={classes.printListBtnBox}>
                                {
                                    contentData.isPrintListOpened ?
                                        <ReturnIcon/> :
                                        <MyListIcon/>
                                }
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box className={classes.printListBtnBox}>
                                <Typography color={`white`} variant={isLaptop ? `body1` :`body2`}>
                                    {contentData.isPrintListOpened ? `חזרה למסך הראשי` : `הצגת רשימת הדפסה`}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Button>
                {
                    countItemOrPromosInPrintList !== 0 && !contentData.isPrintListOpened &&
                    <Box className={classes.bubbleCount}>
                        <Typography textAlign={`center`}>
                            {countItemOrPromosInPrintList}
                        </Typography>
                    </Box>
                }
            </Box>
        </Box>
    )
}